import { Typography } from '@material-ui/core'
import { FC, memo } from 'react'

import { useStyles } from './styles'

interface InfoProps {
  title: string
  demandName: string
  gsd: number
  datum: string
  flightDate?: string
  concludedAt?: string
  totalArea?: number
}

const Info: FC<InfoProps> = ({
  title,
  demandName,
  gsd,
  datum,
  flightDate,
  concludedAt,
  totalArea,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <header>
        <Typography variant='h3'>{title}</Typography>
      </header>

      <section>
        <span>
          <Typography>Nome: </Typography>
          <Typography>{demandName}</Typography>
        </span>
        <span>
          <Typography>GSD: </Typography>
          <Typography>{gsd.toFixed(2)}cm/px</Typography>
        </span>
        <span>
          <Typography>DATUM: </Typography>
          <Typography>{datum}</Typography>
        </span>
        <span>
          <Typography>Voo: </Typography>
          <Typography>{flightDate}</Typography>
        </span>
        <span>
          <Typography>Diagnóstico: </Typography>
          <Typography>{concludedAt}</Typography>
        </span>
        <span>
          <Typography>Área total: </Typography>
          <div>
            <Typography>{totalArea?.toFixed(2)} ha</Typography>
            <Typography>(100%)</Typography>
          </div>
        </span>
      </section>
    </div>
  )
}

export default memo(Info)
